module.exports = __webpack_public_path__ + "static/media/gallery-icon.705e691a.svg";